"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlainObject = void 0;
function isPlainObject(x) {
    if (typeof x !== 'object' || x === null)
        return false;
    var proto = Object.getPrototypeOf(x);
    return proto === null || proto === Object.prototype;
}
exports.isPlainObject = isPlainObject;
//# sourceMappingURL=is-plain-object.js.map